module.exports = __webpack_public_path__ + "81f996891e2f26a49f39fae5dc24c35a.woff";